<div class="tag-list">
    @for (tag of tags(); track tag.value) {
        @if (clicked.observed) {
            <app-tag [option]="tag" (clicked)="clicked.emit($event)" />
        } @else if (!isDisabled()) {
            <app-tag [option]="tag" (removed)="onRemove($event)" />
        } @else {
            <app-tag [option]="tag" />
        }
    }
</div>
